import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  AggregateCommandActionListItemDTO,
  SceneActionListItemDTO,
} from '@/../client-generator/generated-clients/plants';

import { getSceneObjectIconFromType } from '@/core/utils/utils';

@Options({
  name: 'AggregateCommand',
  props: {
    aggregateCommand: {
      required: true,
      type: Object as PropType<AggregateCommandActionListItemDTO>,
    },
  },
  emits: ['add-action'],
})
export default class AggregateCommand extends Vue {
  getSceneObjectIconFromType = getSceneObjectIconFromType;

  aggregateCommand!: AggregateCommandActionListItemDTO;
  isExpanded = false;

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  handleAddObject(action: SceneActionListItemDTO) {
    this.$emit('add-action', action);
  }
}
